import React from "react";
import { trpc } from "../main/components/ProviderContainer.tsx";

const SuperPdpConnectionSettings = () => {
  const utils = trpc.useUtils();
  const { data: connectionStatus, isLoading } =
    trpc.superPdp.getConnectionStatus.useQuery();
  const [clientId, setClientId] = React.useState("");
  const [clientSecret, setClientSecret] = React.useState("");
  const configureMutation = trpc.superPdp.configureProduction.useMutation({
    onSuccess: async () => {
      setClientSecret("");
      await utils.superPdp.invalidate();
    },
  });

  const canSubmit =
    clientId.trim().length > 0 && clientSecret.trim().length > 0;

  return (
    <div className="card col-md-6 mt-2">
      <div className="card-header">
        <h3 className="card-title pt-2">Connexion Super-PDP de production</h3>
      </div>
      <div className="card-body">
        <p className="text-muted">
          Les identifiants sont vérifiés avant enregistrement. La clé secrète
          n&apos;est jamais affichée après sa saisie.
        </p>
        {isLoading ? (
          <div className="text-muted">Chargement de la connexion...</div>
        ) : null}
        {connectionStatus?.production.configured ? (
          <div className="alert alert-success" role="alert">
            Connexion de production configurée (
            {connectionStatus.production.clientId}). Renseignez une nouvelle clé
            pour la remplacer.
          </div>
        ) : (
          <div className="alert alert-warning" role="alert">
            Aucune connexion Super-PDP de production n&apos;est configurée.
          </div>
        )}
        <div className="mb-3">
          <label className="form-label" htmlFor="superpdp-client-id">
            Client ID
          </label>
          <input
            id="superpdp-client-id"
            className="form-control"
            autoComplete="off"
            value={clientId}
            onChange={(event) => setClientId(event.currentTarget.value)}
          />
        </div>
        <div className="mb-3">
          <label className="form-label" htmlFor="superpdp-client-secret">
            Client secret
          </label>
          <input
            id="superpdp-client-secret"
            className="form-control"
            type="password"
            autoComplete="new-password"
            value={clientSecret}
            onChange={(event) => setClientSecret(event.currentTarget.value)}
          />
        </div>
        {configureMutation.data ? (
          <div className="alert alert-success" role="alert">
            Connexion vérifiée pour {configureMutation.data.company.formalName}{" "}
            ({configureMutation.data.company.env}).
          </div>
        ) : null}
        {configureMutation.error ? (
          <div className="alert alert-danger" role="alert">
            {configureMutation.error.message}
          </div>
        ) : null}
        <button
          type="button"
          className="btn btn-primary"
          disabled={!canSubmit || configureMutation.isPending}
          onClick={() => {
            configureMutation.mutate({
              clientId: clientId.trim(),
              clientSecret: clientSecret.trim(),
            });
          }}
        >
          {configureMutation.isPending
            ? "Vérification..."
            : "Vérifier et enregistrer"}
        </button>
      </div>
    </div>
  );
};

export default SuperPdpConnectionSettings;
